import { render, staticRenderFns } from "./dialog-address.vue?vue&type=template&id=1cac4bb7&scoped=true"
import script from "./dialog-address.vue?vue&type=script&lang=js"
export * from "./dialog-address.vue?vue&type=script&lang=js"
import style0 from "./dialog-address.vue?vue&type=style&index=0&id=1cac4bb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cac4bb7",
  null
  
)

export default component.exports